"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaveOpsService = void 0;
var inversify_1 = require("inversify");
var notifyEvents_1 = require("../constants/notifyEvents");
var types_1 = require("../types");
var LeaveOpsService = /** @class */ (function () {
    function LeaveOpsService() {
    }
    LeaveOpsService.prototype.makeCurrentRouteLeave = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentRoute;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.routeStackService.getCurrent()];
                    case 1:
                        currentRoute = _a.sent();
                        if (!currentRoute) return [3 /*break*/, 3];
                        // 有可能只记录了路由信息的 isLeaveComplete
                        // 页面 leave 事件并没有生成和发送，因为 observableService 只是通知，不能对结果做等待
                        return [4 /*yield*/, this.routeStackService.leave()];
                    case 2:
                        // 有可能只记录了路由信息的 isLeaveComplete
                        // 页面 leave 事件并没有生成和发送，因为 observableService 只是通知，不能对结果做等待
                        _a.sent();
                        this.observableService.notify(notifyEvents_1.NOTIFY_ROUTE_LEAVE, {
                            createTime: currentRoute.createTime,
                            uri: currentRoute.uri,
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LeaveOpsService.prototype.makePrevRouteLeave = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentRoute, routes;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.routeStackService.getCurrent()];
                    case 1:
                        currentRoute = _a.sent();
                        return [4 /*yield*/, this.routeStackService.getRoutes()];
                    case 2:
                        routes = _a.sent();
                        // 当前页面为跳转完成，检查之前的页面是否已完成离开事件生成
                        if ((currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.uri) === window.location.href && routes.length > 1) {
                            routes.slice(0, routes.length - 1).forEach(function (route, index) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!!route.isLeaveComplete) return [3 /*break*/, 2];
                                            this.observableService.notify(notifyEvents_1.NOTIFY_PREV_ROUTE_LEAVE, {
                                                createTime: route.createTime,
                                                uri: route.uri,
                                            });
                                            // 更新前一个route为已完成离开
                                            route.isLeaveComplete = true;
                                            return [4 /*yield*/, this.routeStackService.updateByIndex(route, index)];
                                        case 1:
                                            _a.sent();
                                            this.observableService.notify(notifyEvents_1.NOTIFY_ROUTE_LEAVE_COMPLETE, {
                                                url: route.uri,
                                            });
                                            _a.label = 2;
                                        case 2: return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IRouteStackService),
        __metadata("design:type", Object)
    ], LeaveOpsService.prototype, "routeStackService", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IObservableService),
        __metadata("design:type", Object)
    ], LeaveOpsService.prototype, "observableService", void 0);
    LeaveOpsService = __decorate([
        (0, inversify_1.injectable)()
    ], LeaveOpsService);
    return LeaveOpsService;
}());
exports.LeaveOpsService = LeaveOpsService;
